/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrder } from '../../models/shop-order';
import { UpdateMgmtShopOrderDto } from '../../models/update-mgmt-shop-order-dto';

export interface UpdateOneBaseMgmtShopOrderControllerShopOrder$Params {
  id: number;
      body: UpdateMgmtShopOrderDto
}

export function updateOneBaseMgmtShopOrderControllerShopOrder(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtShopOrderControllerShopOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrder>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtShopOrderControllerShopOrder.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrder>;
    })
  );
}

updateOneBaseMgmtShopOrderControllerShopOrder.PATH = '/api/shop/mgmt-shop-orders/{id}';
